import IProxy from './IProxy';

export class NotImplementedProxy implements IProxy {
	public async isEnabled(): Promise<boolean> {
		throw new Error('Method not implemented.');
	}

	public async setManual(): Promise<void> {
		throw new Error('Method not implemented.');
	}

	public async disable(): Promise<void> {
		throw new Error('Method not implemented.');
	}

	public async getConnectedTo(): Promise<string> {
		throw new Error('Method not implemented.');
	}
}
